export default "__VITE_ASSET__DkC$MrCh__"